import React from 'react';
import noContentSrc from 'images/ollie_calendar.svg';
import noResultsSrc from 'images/content_no_results.svg';
import IndexDataView from '../../shared/index/data_view';
import { routes } from '../../../constants/config';

const ContentDataView = ({ ...props }) => {
  const blankSlates = {
    hasFailed: {
      icon: `${routes.ASSETS_BLANK_SLATES}/danger.svg`,
    },
    noResults: {
      title: t('in_person_training.events.blank_slate.no_results.title'),
      description: t(
        'in_person_training.events.blank_slate.no_results.description',
      ),
      image: noResultsSrc,
      icon: `${routes.ASSETS_BLANK_SLATES}/filter.svg`,
    },
    noContent: {
      image: noContentSrc,
      title: t('in_person_training.events.blank_slate.no_content.title'),
      description: t(
        'in_person_training.events.blank_slate.no_content.description',
      ),
      children: (
        <div className="mt-16 fz-bigger">
          <span className="c-brand-gray-dark">
            {t(
              'in_person_training.events.blank_slate.no_content.call_to_action',
            )}
          </span>
          &nbsp;
          <a className="u-link" href={routes.IN_PERSON_TRAINING.NEW_EVENT}>
            {t(
              'in_person_training.events.blank_slate.no_content.call_to_action_link',
            )}
          </a>
        </div>
      ),
    },
  };

  return (
    <IndexDataView {...props} selectable={false} blankSlates={blankSlates} />
  );
};

export default ContentDataView;
